import {useCallback, useState} from "react";
import {validateFields, type FieldRule} from "@zaaaz/shared";
import type {I18nKey} from "@zaaaz/shared";

export function useFormValidation<T extends string>() {
  const [errors, setErrors] = useState<Partial<Record<T, string>>>({});

  const clearError = useCallback((field: T) => {
    setErrors((prev) => {
      if(!prev[field]) return prev;
      const next = {...prev};
      delete next[field];
      return next;
    });
  }, []);

  const clearErrors = useCallback(() => setErrors({}), []);

  const validate = useCallback((rules: FieldRule<T>[], values: Record<string, unknown>, t: (key: I18nKey) => string): boolean => {
    const next = validateFields(rules, values, t);
    setErrors(next);
    return Object.keys(next).length === 0;
  }, []);

  return {errors, clearError, clearErrors, validate, setErrors};
}
